module.exports = __webpack_public_path__ + "img/tu06.92955492.png";